import { serviceRequest } from 'utils/http';
import { Service, SiteEmployeeDto } from 'common/api';

export function updateCurrentSiteEmployeeAPI(requestBody: SiteEmployeeDto) {
  return serviceRequest(() => Service.siteEmployeeControllerUpdateCurrentSiteEmployee(requestBody));
}
